module.exports = __webpack_public_path__ + "img/h-kl1.35148648.png";